<template>
  <div class="box boxbgcolor">
    <el-row :gutter="10">
      <el-col :span="8">
        <div class="grid-content bg-purple">
          <div class="box parentflex">
            <p>今日用能统计/能源折算/总产量</p>
            <div class="content flex">
              <div class="cardflex">
                <div class="card padding flex">
                  <div class="box_ parentbox">
                    <div class="valuebox">
                      <p>总用电量</p>
                      <p class="danwei">( kW·h)</p>
                    </div>
                    <div class="valuebox bgpadding">
                      <div class="valuebg valuebgcolor">
                        <p>{{ this.elevalue }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card padding flex">
                  <div class="box_ parentbox">
                    <div class="valuebox">
                      <p>总用水量</p>
                      <p class="danwei">(m³)</p>
                    </div>
                    <div class="valuebox bgpadding">
                      <div class="valuebg valuebgcolor">
                        <p>{{ this.watervalue }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card padding flex">
                  <div class="box_ parentbox">
                    <div class="valuebox">
                      <p>总产量</p>
                      <p class="danwei">(片)</p>
                    </div>
                    <div class="valuebox bgpadding">
                      <div class="valuebg valuebgcolor">
                        <p>{{ this.allvalue }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cardflex">
                <div class="card padding flex">
                  <div class="box_ parentbox">
                    <div class="valuebox">
                      <p class="bluetxt bluecolor">{{ this.elevalueNum }}</p>
                      <p class="danwei bluecolor">(吨标准煤)</p>
                    </div>
                    <div class="valuebox bgpadding">
                      <div class="valuebg">
                        <div class="energyImg yearele_"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card padding flex">
                  <div class="box_ parentbox">
                    <div class="valuebox">
                      <p class="bluetxt bluecolor">{{ this.watervalueNum }}</p>
                      <p class="danwei bluecolor">(吨标准煤)</p>
                    </div>
                    <div class="valuebox bgpadding">
                      <div class="valuebg">
                        <div class="energyImg yearWater_"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card padding flex">
                  <div class="box_ parentbox">
                    <div class="valuebox">
                      <p class="bluetxt bluecolor">{{ this.allvalueNum }}</p>
                      <p class="danwei bluecolor">(吨标准煤)</p>
                    </div>
                    <div class="valuebox bgpadding">
                      <div class="valuebg">
                        <div class="energyImg yearall_"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content bg-purple">
          <div class="box_ parentflex">
            <p>今日单片能耗</p>
            <div class="content">
              <div class="pagebox" id="todaycharts"></div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content bg-purple">
          <div class="box_ parentflex">
            <p>年/月/周/日 {{ trendTxt }}</p>
            <div class="content">
              <ul class="countUl">
                <li style="
                    background: rgba(122, 41, 204, 0.6);
                    color: #7a29cc;
                    font-weight: bold;
                  ">
                  Year
                </li>
                <li style="
                    background: rgba(0, 54, 140, 0.6);
                    color: #00368c;
                    font-weight: bold;
                  ">
                  Month
                </li>
                <li style="
                    background: rgba(230, 191, 0, 0.6);
                    color: #e6bf00;
                    font-weight: bold;
                  ">
                  Week
                </li>
                <li style="
                    background: rgba(46, 168, 230, 0.6);
                    color: #2ea8e6;
                    margin-right: 0;
                    font-weight: bold;
                  ">
                  Day
                </li>
              </ul>
              <div class="pagebox" id="yearEcharts" style="border: none"></div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="16">
        <div class="grid-content bg-purple">
          <div class="box_ parentflex_main">
            <span class="texttyle">{{ leftdowntext }}</span>
            <span class="dayLink">
              <a :class="
                  active == 'ele' ? 'dayElect ele active' : 'dayElect ele'
                " type="电" @click="witchLook('ele')" title="查看电用量"></a>
              <a :class="
                  active == 'water' ? 'dayWater water active' : 'dayWater water'
                " type="水" @click="witchLook('water')" title="查看水用量"></a>
            </span>
            <div class="content">
              <div class="pagebox" id="line"></div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content bg-purple">
          <div class="box_ parentflex">
            <p>{{ pietxt }}</p>
            <div class="content">
              <div class="pagebox" id="pie"></div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import api from '@common/api/index.js'
import {
  getDate,
  findDataByParam,
  formatDate,
  formatTime,
  getX,
  getxData,
} from '@/utils/index'
export default {
  name: 'Main',
  data () {
    return {
      measureId: '', //计量点id
      measureIdEle: '', //计量点id
      measureIdWater: '', //计量点id
      measureIdLng: '', //计量点id
      elevalue: '-', //总用电量
      watervalue: '-', //总用水量
      allvalue: '-', //总用量
      elevalueNum: '-', //总用电量系数
      watervalueNum: '-', //总用水量系数
      allvalueNum: '-', //总用量系数

      pageFlag: true,
      data: {
        Chartpietree: null, //三仪表盘
        myChartYearEcharts: null, //右上柱状
        myChartPie: null, //饼图
      },
      active: 'ele',
      fourchartdata: {
        xdata: [],
        ydata: [],
      },
      leftdowntext: '当日电用能',
      leftdownele: [], //左下曲线电的昨日今日
      leftdownwater: [], //左下曲线水的昨日今日
      piemyselfData: [], //自定义pie数据
      elepie: [], //电圆环
      waterpie: [], //水圆环
      pietxt: '当日车间用电占比',
      todayTime: '', //今天日期-结束
      lastdayTime: '', //昨天日期-开始
      eleparams: '', //电系数
      waterparams: '', //水系数
      todayFrom: '',
      todayTo: '',
      lastdayFrom: '',
      lastdayTo: '',
      inter: null,
      elepieId: [],
      waterpieId: [],
      chartMaxMinData: {
        left: {
          min: 0,
          max: 1,
        },
      },
      trendTxt: '单片能耗趋势（kW·h/片）',
      warningLineValueObject: {},
    }
  },
  created () {
    // this.fourchartdata.xdata = this.getxData();
    this.fourchartdata.xdata = getxData()
    let nextDate = new Date()
    nextDate.setDate(nextDate.getDate() + 1)
    this.todayTime =
      formatDate(
        new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
        'yyyy-MM-dd'
      ) + ' 00:00:00'
    this.lastdayTime =
      formatDate(
        new Date(new Date().getTime() - 24 * 60 * 60 * 1000),
        'yyyy-MM-dd'
      ) + ' 00:00:00'
    this.todayFrom =
      formatDate(new Date(new Date().getTime()), 'yyyy-MM-dd') + ' 00:00:00'
    this.todayTo = formatDate(nextDate, 'yyyy-MM-dd') + ' 00:00:00'
    this.lastdayFrom =
      formatDate(
        new Date(new Date().getTime() - 24 * 60 * 60 * 1000),
        'yyyy-MM-dd'
      ) + ' 00:00:00'
    this.lastdayTo =
      formatDate(new Date(new Date().getTime()), 'yyyy-MM-dd') + ' 00:00:00'
    this.getmeasureId() //获取自定义的measureId
    this.getPiemysele() //获取自定义圆环统计的measureId
    this.inter = setInterval(() => {
      this.getmeasureId() //获取自定义的measureId
      this.getPiemysele() //获取自定义圆环统计的measureId
    }, 1000 * 60)
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调
    if (this.inter) {
      clearInterval(this.inter)
      this.inter = null
    }
    next()
  },
  beforeDestrioy () {
    if (this.inter) {
      clearInterval(this.inter)
      this.inter = null
    }
  },
  activated () {
    if (this.inter) {
      clearInterval(this.inter)
      this.inter = null
    }
    this.inter = setInterval(() => {
      this.getmeasureId() //获取自定义的measureId
      this.getPiemysele() //获取自定义圆环统计的measureId
    }, 1000 * 60)
  },
  mounted () {
    //this.getfourchartsdata();
    this.fillYearEcharts(this.fourchartdata)
    /* var threedata = [[{value: 10, name: '单片用电\n(kw.h/片)'}],[{value:10, name: '单片综合能耗\n(吨标准煤/片)'}],[{value:2, name: '单片用水\n(L/片)'}]]
       this.filltreepie(threedata) */
    //右下饼图
    // let piedata_ = [["CEF",185998.77],["LOG",40215.04],["ENG",125563.6]]
    // this.reFresh(piedata_)//饼图
  },
  watch: {
    elepie (curval, oldval) {
      if (this.active == 'ele') {
        this.reFresh(this.elepie) //圆环图
      } else {
        this.reFresh(this.waterpie)
      }
    },
    leftdownele (curval, oldval) {
      if (this.active == 'ele') {
        this.setLineData_(this.leftdownele) //左下图
      } else {
        this.setLineData_(this.leftdownwater)
      }
    },
  },
  methods: {
    getmeasureId () {
      //获取当前页面的measureId
      let roleId = '0',
        pagePath = '/main/main'
      /* let url = "/main/mpid",
        params = "measureId"; */
      let vm = this
      api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(roleId, pagePath, '')
        .then((res) => {
          if (res.success) {
            //模拟数据

            // if (res.data.length == 0) {
            //   res.data = [
            //     { param: "measureIdLng", value: "700000000006" },
            //     {
            //       param: "chartMaxMinData",
            //       value: JSON.stringify({
            //         left: {
            //           min: 0,
            //           max: 0.1,
            //           oneMax: 0.2,
            //           twoMax: 0.8,
            //         },
            //         center: {
            //           min: 0,
            //           max: 3,
            //           oneMax: 0.2,
            //           twoMax: 0.8,
            //         },
            //         right: {
            //           min: 0,
            //           max: 25,
            //           oneMax: 0.2,
            //           twoMax: 0.8,
            //         },
            //       }),
            //     },
            //     { param: "measureIdEle", value: "800000000001" },
            //     { param: "mainMpId", value: "800000000001" },

            //     {
            //       param: "water",
            //       value: JSON.stringify([
            //         { name: "Sur-A", mpid: "800000000002" },
            //         { name: "Sur-B", mpid: "800000000003" },
            //         { name: "Tinting", mpid: "800000000004" },
            //         { name: "HC", mpid: "800000000005" },
            //         { name: "AR", mpid: "800000000006" },
            //         { name: "HR", mpid: "800000000007" },
            //         { name: "ME", mpid: "800000000010" },
            //       ]),
            //     },
            //     { param: "measureIdWater", value: "600000000001" },
            //     {
            //       param: "ele",
            //       value: JSON.stringify([
            //         { name: "Sur-A", mpid: "800000000002" },
            //         { name: "Sur-B", mpid: "800000000003" },
            //         { name: "Tinting", mpid: "800000000004" },
            //         { name: "HC", mpid: "800000000005" },
            //         { name: "AR", mpid: "800000000006" },
            //         { name: "HR", mpid: "800000000007" },
            //         { name: "Packing", mpid: "800000000008" },
            //         { name: "LOG", mpid: "800000000009" },
            //         { name: "ME", mpid: "800000000010" },
            //         { name: "CEF", mpid: "800000000011" },
            //       ]),
            //     },
            //     {
            //       param: "warningLineValue",
            //       value: JSON.stringify({
            //         eleLineValue: 4,
            //         woterLineValue: 0.02,
            //       }),
            //     }, //警戒线值
            //   ];
            // }
            this.eleparams = findDataByParam(
              'StandardCoalCoefficientOfElectricity',
              false,
              res.data
            ) //电折标
            this.waterparams = findDataByParam(
              'StandardCoalCoefficientOfWater',
              false,
              res.data
            ) //水折标

            vm.measureId = findDataByParam('mainMpId', false, res.data)
            vm.measureIdEle = findDataByParam('measureIdEle', false, res.data)

            vm.chartMaxMinData = findDataByParam(
              'chartMaxMinData',
              true,
              res.data
            )
            vm.measureIdWater = findDataByParam(
              'measureIdWater',
              false,
              res.data
            )
            vm.measureIdLng = findDataByParam('measureIdLng', false, res.data)
            vm.warningLineValueObject = findDataByParam(
              'warningLineValue',
              true,
              res.data
            )
            vm.getRightData() //右上数据
            vm.getlinedata() //左下数据
            vm.getCardUse()
          }
        })
    },

    getCardUse () {
      let nextDate = new Date()
      nextDate.setDate(nextDate.getDate() + 1)
      let {
        measureIdEle,
        measureIdWater,
        measureIdLng,
        startTime,
        endTime,
        pointCode,
        pointNumber,
      } = {
        measureIdEle: this.measureIdEle,
        measureIdWater: this.measureIdWater,
        measureIdLng: this.measureIdLng,
        startTime: formatDate(new Date(), 'yyyy-MM-dd') + ' 00:00:00',
        endTime: formatDate(nextDate, 'yyyy-MM-dd') + ' 00:00:00',
        pointNumber: '0',
      }
      let pointCodeele = '100229' //电
      let p1 = api.quantity.getQuantity(
        measureIdEle,
        startTime,
        endTime,
        pointCodeele,
        pointNumber
      )
      let pointCodeWater = '100401' //水
      let p2 = api.quantity.getQuantity(
        measureIdWater,
        startTime,
        endTime,
        pointCodeWater,
        pointNumber
      )
      let pointCodeall = 100701 //总产量
      let p3 = this.$api.quantity.getQuantity2(
        // measureIdLng,
        JSON.stringify([
          {
            measureId: measureIdLng,
            pointNumber: pointNumber,
            pointCode: pointCodeall,
          },
        ]),
        startTime,
        endTime,
        []
        // pointCodeall,
        // pointNumber
      )
      Promise.all([p1, p2, p3]).then((result) => {
        if (result.includes(null)) {
          return
        }

        //卡片数据
        this.elevalue =
          result[0].data == null ? '0.00' : result[0].data.toFixed(2)
        this.elevalueNum = (this.elevalue * this.eleparams).toFixed(2) //系数
        this.watervalue =
          result[1].data == null ? '0.00' : result[1].data.toFixed(2)
        this.watervalueNum = (this.watervalue * this.waterparams).toFixed(2) //系数
        if (!result[2].data[0].value) {
          this.allvalue = '0.00'
        } else {
          this.allvalue =
            result[2].data[0].value == null
              ? '0.00'
              : result[2].data[0].value.toFixed(2)
        }
        // this.allvalue =
        //   result[2].data[0][0].value == null
        //     ? "0.00"
        //     : result[2].data[0][0].value.toFixed(2);
        this.allvalueNum = (
          Number(this.elevalueNum) + Number(this.watervalueNum)
        ).toFixed(2)
        //卡片数据
        //仪表盘数据
        let danpianele =
          this.elevalue == 0 || this.allvalue == 0
            ? 0
            : parseInt((this.elevalue / this.allvalue) * 100) / 100 //单片用电  //用电量除产量
        let danpianwater =
          this.watervalue == 0 || this.allvalue == 0
            ? 0
            : (
              (parseFloat((this.watervalue / this.allvalue) * 100) / 100) *
              1000
            ).toFixed(2) //单片用水
        // let danpianele =
        //   this.elevalue == 0 || this.allvalue == 0
        //     ? 0
        //     : parseInt((this.elevalue / this.allvalue) * 100) / 100; //单片用电  //用电量除产量
        // let danpianwater =
        //   this.watervalue == 0 || this.allvalue == 0
        //     ? 0
        //     : parseInt((this.watervalue / this.allvalue) * 100) / 100; //单片用水
        let danpianall =
          this.allvalue == 0
            ? 0
            : (
              ((((this.elevalue * this.eleparams) / this.allvalue +
                (this.watervalue * this.waterparams) / this.allvalue) *
                100) /
                100) *
              1000
            ).toFixed(4) //单片用电*电系数 /总产量 + 单片用水*水系数 /总产量

        let threedata = [
          [{ value: danpianele, name: '单片用电\n(kW·h/片)' }],
          [{ value: danpianall, name: '单片综合能耗\n(kgce/片)' }],
          [{ value: danpianwater, name: '单片用水\n(L/片)' }],
        ]
        this.filltreepie(threedata)
        //仪表盘数据
      })
    },

    //获取右上角的图表的数据
    getRightData () {
      let vm = this
      let measureId = this.measureId
      let measureIdtwo = this.measureIdLng
      let arr = []
      let rate = 1

      if (this.active == 'ele') {
        //用电
        arr = vm.getApiArr(['100229', '100701'], [measureId, measureIdtwo])
        vm.fourchartdata.warningLineValue =
          vm.warningLineValueObject.eleLineValue
        rate = 1
      } else {
        //用水
        arr = vm.getApiArr(['100401', '100701'], [measureId, measureIdtwo])
        vm.fourchartdata.warningLineValue =
          vm.warningLineValueObject.woterLineValue
        rate = 1000
      }

      Promise.all(arr).then((res) => {
        if (res.includes(null)) {
          return
        }

        let eleYearData = getX(res[0].data, 5)
        let ctrYearData = getX(res[1].data, 5)

        let eleMonthData = process(getX(res[2].data, 4, true), 'time')
        // let ctrMonthData = getX(res[3].data, 4, true);
        let ctrMonthData = process(getX(res[3].data, 4, true), 'time')
        function process (list, attrName) {
          if (!(list instanceof Array)) {
            return 0
          }
          if (!!attrName === false) {
            return -1
          }
          var newList = []
          for (var i = 0; i < list.length; i++) {
            var flag = true
            for (var j = 0; j < newList.length; j++) {
              if (list[i][attrName] == newList[j][attrName]) {
                flag = false
              }
            }
            if (flag) {
              newList.push(list[i])
            }
          }
          return newList
          // // 缓存用于记录
          // const cache = [];
          // for (const t of arr) {
          //   // 检查缓存中是否已经存在
          //   if (
          //     cache.find(
          //       c =>
          //         c.maxDeptCode === t.maxDeptCode &&
          //         c.minDeptCode === t.minDeptCode
          //     )
          //   ) {
          //     // 已经存在说明以前记录过，现在这个就是多余的，直接忽略
          //     continue;
          //   }
          //   // 不存在就说明以前没遇到过，把它记录下来
          //   cache.push(t);
          // }

          // // 记录结果就是过滤后的结果
          // return cache;
        }
        let eleWeekData = getX(res[4].data[0], 3)
        let ctrWeekData = getX(res[5].data[0], 3)
        let eleDayData = getX(res[6].data[0], 2)
        let ctrDayData = getX(res[7].data[0], 2)

        let yeartlose = vm.settleData(ctrYearData, eleYearData, 2, rate)
        let mouthlose = vm.settleData(ctrMonthData, eleMonthData, 7, rate)
        let weeklose = vm.settleData(ctrWeekData, eleWeekData, 12, rate)
        let hourlose = vm.settleData(ctrDayData, eleDayData, 19, rate)
        let yData = []
        yData.push(yeartlose, mouthlose, weeklose, hourlose)

        vm.fourchartdata.ydata = yData

        vm.fillYearEcharts(vm.fourchartdata)
        vm.getbottomData(measureId, '100229', '0')
      })
    },
    /**
     * 根据codes拿到api请求集合
     */
    getApiArr (codes, measureId) {
      let vm = this
      let arr = []
      var nowDate = new Date()
      let lastYearNum = nowDate.getFullYear()
      let thisYearNum = nowDate.getFullYear()
      let nowtime = new Date()
      nowtime.setFullYear(nowtime.getFullYear())
      let startTime = formatDate(nowtime, 'yyyy') + '/01/01 00:00:00'
      nowtime.setFullYear(nowtime.getFullYear() + 1)
      let endTime = formatDate(nowtime, 'yyyy') + '/01/01 00:00:00'
      //let startMonth = nowDate.getMonth()+1 - 4;
      let item1 = new Date().setMonth(new Date().getMonth() - 5)
      let startMonth = formatDate(new Date(item1), 'yyyy-MM') //前五个月的日期
      let endMonth = nowDate.getMonth() + 1 //当前月   5
      endMonth = endMonth < 10 ? '0' + endMonth : endMonth
      let startWeek = new Date()
      let endWeek = new Date()
      let startDay = new Date()
      let endDay = new Date()
      endDay.setDate(endDay.getDate() + 1)
      startDay.setDate(endWeek.getDate() - 6)
      endWeek.setDate(endWeek.getDate() + (7 - endWeek.getDay()))
      startWeek.setDate(endWeek.getDate() - 35)
      let dTime = new Date()
      endWeek.setDate(
        endWeek.getDate() + (7 - (endWeek.getDay() == 0 ? 7 : endWeek.getDay()))
      )
      startWeek.setDate(endWeek.getDate() - 35)
      let nowTime = formatDate(endWeek, 'yyyy-MM-dd hh:mm:ss') //拿取当前时间
      var timestamp = Date.parse(nowTime) / 1000
      let ee = timestamp - 86400 * 34
      let newE = timestamp + 86400
      startTime = formatTime(ee, 'Y-M-D ') + '00:00:00' //时段的环期开始时间
      endTime = formatTime(newE, 'Y-M-D ') + '00:00:00' //时段的环期结束时间

      let mouthTime = new Date()
      let MouthendTime
      let MouthstartTime
      mouthTime.setMonth(mouthTime.getMonth() + 1)
      MouthendTime = formatDate(mouthTime, 'yyyy-MM') + '/01 00:00:00'
      mouthTime.setMonth(mouthTime.getMonth() - 5)
      MouthstartTime = formatDate(mouthTime, 'yyyy-MM') + '/01 00:00:00'

      // for (var i in codes) {
      //   let code = codes[i];
      //   }
      //获取去年的电能数据
      arr.push(
        vm.$api.quantity.getQuantityYear(
          measureId[0],
          lastYearNum - 1 + '/01/01 00:00:00',
          thisYearNum + 1 + '/01/01 00:00:00',
          codes[0],
          '0'
        )
      )
      arr.push(
        vm.$api.quantity.getQuantityYear(
          measureId[1],
          lastYearNum - 1 + '/01/01 00:00:00',
          thisYearNum + 1 + '/01/01 00:00:00',
          codes[1],
          '0'
        )
      )
      //获取5个月的电能数据
      arr.push(
        vm.$api.quantity.getQuantityMonth(
          // measureId,
          // startMonth + "/01 00:00:00",
          // thisYearNum + "-" + endMonth + "/01 00:00:00",
          // code,
          // "0"
          measureId[0],
          MouthstartTime,
          MouthendTime,
          codes[0],
          '0'
        )
      )
      arr.push(
        vm.$api.quantity.getQuantityMonth(
          // measureId,
          // startMonth + "/01 00:00:00",
          // thisYearNum + "-" + endMonth + "/01 00:00:00",
          // code,
          // "0"
          measureId[1],
          MouthstartTime,
          MouthendTime,
          codes[1],
          '0'
        )
      )
      arr.push(
        vm.$api.quantity.getQuantityDay(
          // measureId,
          // formatDate(startWeek, "yyyy-MM-dd") + " 00:00:00",
          // formatDate(endWeek, "yyyy-MM-dd") + " 00:00:00",
          // null,
          // code,
          // "0"
          measureId[0],
          startTime,
          endTime,
          null,
          codes[0],
          '0'
        )
      )
      arr.push(
        vm.$api.quantity.getQuantityDay(
          // measureId,
          // formatDate(startWeek, "yyyy-MM-dd") + " 00:00:00",
          // formatDate(endWeek, "yyyy-MM-dd") + " 00:00:00",
          // null,
          // code,
          // "0"
          measureId[1],
          startTime,
          endTime,
          null,
          codes[1],
          '0'
        )
      )
      arr.push(
        vm.$api.quantity.getQuantityDay(
          measureId[0],
          formatDate(startDay, 'yyyy-MM-dd') + ' 00:00:00',
          formatDate(endDay, 'yyyy-MM-dd') + ' 00:00:00',
          null,
          codes[0],
          '0'
        )
      )
      arr.push(
        vm.$api.quantity.getQuantityDay(
          measureId[1],
          formatDate(startDay, 'yyyy-MM-dd') + ' 00:00:00',
          formatDate(endDay, 'yyyy-MM-dd') + ' 00:00:00',
          null,
          codes[1],
          '0'
        )
      )
      return arr
    },
    //获取底部图表的数据
    getbottomData (measureId, pointCode, pointNumber) {
      let vm = this
      let thisDate = new Date()
      let thisNextDate = new Date()
      thisNextDate.setDate(thisNextDate.getDate() + 1)
      let lasrDate = new Date(thisDate.getTime() - 24 * 60 * 60 * 1000)
      let lastDay = vm.$api.quantity.getQuantityHour(
        measureId,
        formatDate(lasrDate, 'yyyy-MM-dd') + ' 00:00:00',
        formatDate(thisDate, 'yyyy-MM-dd') + ' 00:00:00',
        pointCode,
        pointNumber
      )
      let thisDay = vm.$api.quantity.getQuantityHour(
        measureId,
        formatDate(thisDate, 'yyyy-MM-dd') + ' 00:00:00',
        formatDate(thisNextDate, 'yyyy-MM-dd') + ' 00:00:00',
        pointCode,
        pointNumber
      )

      Promise.all([lastDay, thisDay]).then((res) => { })
    },
    getxData () {
      let timex = []
      let newtime = new Date().getTime()
      let newyear = formatDate(new Date(newtime), 'yyyy')
      let lastyear = newyear - 1
      let yearx = [String(lastyear), newyear]
      let newmouth = formatDate(new Date(newtime), 'MM')
      let mouthx = []
      for (let i = 0; i < 5; i++) {
        let item = new Date().setMonth(new Date().getMonth() - (4 - i))
        mouthx.push(this.getMouth_(formatDate(new Date(item), 'MM')))
      }
      let weekx = []
      for (let i = 0; i < 5; i++) {
        let item = new Date().getTime() - 7 * (4 - i) * 3600 * 24 * 1000
        weekx.push(this.getWeek_(formatDate(new Date(item), 'yyyy-MM-dd')))
      }
      let dayx = []
      for (let i = 0; i < 7; i++) {
        let item = new Date().getTime() - (6 - i) * 3600 * 24 * 1000
        dayx.push(formatDate(new Date(item), 'MM.dd'))
      }
      timex = [...yearx, ...mouthx, ...weekx, ...dayx]
      return timex
    },
    getWeek_ (dt) {
      let d1 = new Date(dt)
      let d2 = new Date(dt)
      d2.setMonth(0)
      d2.setDate(1)
      let rq = d1 - d2
      let days = Math.ceil(rq / (24 * 60 * 60 * 1000))
      let num = Math.ceil(days / 7 + 1)
      return 'w' + num
    },
    getMouth_ (date) {
      switch (date) {
        case '01':
          return 'Jan'
          break
        case '02':
          return 'Feb'
          break
        case '03':
          return 'Mar'
          break
        case '04':
          return 'Apr'
          break
        case '05':
          return 'May'
          break
        case '06':
          return 'Jun'
          break
        case '07':
          return 'Jul'
          break
        case '08':
          return 'Aug'
          break
        case '09':
          return 'Sep'
          break
        case '10':
          return 'Oct'
          break
        case '11':
          return 'Nov'
          break
        case '12':
          return 'Dec'
          break
        default:
          return ''
      }
    },

    getlinedata () {
      //左下曲线
      let vm = this
      let {
        measureId,
        measureIdEle,
        measureIdWater,
        startTime,
        endTime,
        laststartTime,
        lastendTime,
        pointCode,
        segments,
        pointNumber,
      } = {
        measureId: vm.measureId,
        measureIdEle: vm.measureIdEle,
        measureIdWater: vm.measureIdWater,
        startTime: vm.todayFrom,
        endTime: vm.todayTo,
        laststartTime: vm.lastdayFrom,
        lastendTime: vm.lastdayTo,
        segments: null,
        pointNumber: '0',
      }
      //当昨日电能
      let lineele = [
        { data: [], name: '当日用电量', totalEq: '' },
        { data: [], name: '昨日用电量', totalEq: '' },
      ]
      /* this.leftdownele.forEach((val,index)=>{
          for(let i=0;i<24;i++){
            val.data.push( { time: i<10?"0"+i+":00":i+":00", value: '-' })
          }
      }) */
      let dayele_pointCode = '100229'
      let elecur = vm.$api.quantity.getQuantityHour(
        vm.measureIdEle,
        startTime,
        endTime,
        dayele_pointCode,
        pointNumber
      )
      let elepro = vm.$api.quantity.getQuantityHour(
        vm.measureIdEle,
        laststartTime,
        lastendTime,
        dayele_pointCode,
        pointNumber
      )
      Promise.all([elecur, elepro]).then((result) => {
        lineele[0].data = this.setLeftDownData(result[0].data)
        lineele[1].data = this.setLeftDownData(result[1].data)
        this.leftdownele = lineele
      })

      //当昨日水能
      let linewater = [
        { data: [], name: '当日用水量', totalEq: '' },
        { data: [], name: '昨日用水量', totalEq: '' },
      ]
      /* this.leftdownwater.forEach((val,index)=>{
          for(let i=0;i<24;i++){
            val.data.push( { time: i<10?"0"+i+":00":i+":00", value: '-' })
          }
      }) */
      let daywater_pointCode = '100401'
      let watercur = vm.$api.quantity.getQuantityHour(
        measureIdWater,
        startTime,
        endTime,
        daywater_pointCode,
        pointNumber
      )
      let waterpro = vm.$api.quantity.getQuantityHour(
        measureIdWater,
        laststartTime,
        lastendTime,
        daywater_pointCode,
        pointNumber
      )
      Promise.all([watercur, waterpro]).then((result) => {
        linewater[0].data = this.setLeftDownData(result[0].data)
        linewater[1].data = this.setLeftDownData(result[1].data)
        this.leftdownwater = linewater
      })
    },
    setLeftDownData (data) {
      let xdata = []
      for (let i = 0; i < 24; i++) {
        xdata.push({ time: i < 10 ? '0' + i + ':00' : i + ':00', value: '-' })
      }
      let newdata = data.map((val, index) => {
        return {
          time: formatDate(new Date(val.time), 'hh:mm'),
          value: val.value.toFixed(2),
        }
      })
      xdata.forEach((val, index) => {
        newdata.forEach((item, y) => {
          if (val.time == item.time) {
            val.value = item.value
          }
        })
      })
      return xdata
    },
    setlinedata (data) {
      /* data=[
        [
          { time: "2019-12-02 08:00", value: 22 },
          { time: "2019-12-03 09:00", value: 32 }
        ],
        [
          { time: "2019-12-02 10:00", value: 62 },
          { time: "2019-12-03 10:00", value: 42 },
        ],
        [
          { time: "2019-12-02 11:00", value: 30 },
        ]
      ]; */
      let temparr = [],
        newday = [],
        preday = [],
        xhour = []
      temparr = [
        { data: [], name: '当日用电量', totalEq: '' },
        { data: [], name: '昨日用电量', totalEq: '' },
      ]
      temparr.forEach((val, index) => {
        for (let i = 0; i < 24; i++) {
          val.data.push({
            time: i < 10 ? '0' + i + ':00' : i + ':00',
            value: '-',
          })
        }
      })
      data.forEach((val, index) => {
        val.forEach((item, j) => {
          let jude = this.lastdayTime
            .split(' ')
            .includes(item.time.split(' ')[0])
          if (jude) {
            preday.push({ time: item.time.split(' ')[1], value: item.value })
          } else {
            newday.push({ time: item.time.split(' ')[1], value: item.value })
          }
        })
      })
      for (let i = 0; i < temparr.length; i++) {
        if (i == 0) {
          newday.forEach((items, index) => {
            temparr[i].data.forEach((val, j) => {
              if (items.time == val.time) {
                val.value = items.value
              }
            })
          })
        } else {
          preday.forEach((items, index) => {
            temparr[i].data.forEach((val, j) => {
              if (items.time == val.time) {
                val.value = items.value
              }
            })
          })
        }
      }
      return temparr
    },
    settleData (alldata, usedata, timenum, rate) {
      //timenum：对应x轴位数
      /* 获取当前年、月、日 */
      let x = []
      var realdata = []
      for (let k = 0; k < timenum; k++) {
        realdata.push('-')
      }
      for (let i = 0; i < usedata.length; i++) {
        //电
        for (let j = 0; j < alldata.length; j++) {
          //产
          if (alldata[j].time == usedata[i].time) {
            for (let z = 0; z < this.fourchartdata.xdata.length; z++) {
              if (alldata[j].time == this.fourchartdata.xdata[z]) {
                realdata[z] =
                  alldata[j].value == 0
                    ? '0.00'
                    : ((usedata[i].value / alldata[j].value) * rate).toFixed(2)
              }
            }
          }
        }
      }
      // for (let i = 0; i < alldata.length; i++) {
      //   for (let j = 0; j < usedata.length; j++) {
      //     if (alldata[i].time == usedata[j].time) {
      //       for (let z = 0; z < this.fourchartdata.xdata.length; z++) {
      //         if (alldata[i].time == this.fourchartdata.xdata[z]) {
      //           realdata[z] =
      //             alldata[i].value == 0
      //               ? "0.00"
      //               : (usedata[j].value / alldata[i].value).toFixed(2);
      //         }
      //       }
      //     }
      //   }
      // }
      return realdata
    },
    //切换点击事件
    witchLook (type) {
      this.active = type
      if (this.active == 'ele') {
        this.leftdowntext = '当日电用能'
        this.pietxt = '当日车间用电占比'
        this.trendTxt = '单片能耗趋势（kW·h/片）'
        this.setLineData_(this.leftdownele)
        this.reFresh(this.elepie)
        this.getRightData()
      } else {
        this.leftdowntext = '当日水用能'
        this.pietxt = '当日车间用水占比'
        this.trendTxt = '单片用水趋势（L/片）'
        this.setLineData_(this.leftdownwater)
        this.reFresh(this.waterpie)
        this.getRightData()
      }
    },
    getPiemysele () {
      let vm = this
      //发送请求获取自定义数据，圆环需要统计的部门
      // let url = "/main/mpid", params = "parments";
      /* api.customUrl.getCustomUrlParam(url, params).then(res => {
        if (res.success) {
          let myselfData = JSON.parse(res.data[0].value)
          this.piemyselfData = myselfData;
          this.getPieChart();
        }
      }); */

      /* let url = "/main/mpid",
        params = "measureId"; */
      let roleId = '0',
        pagePath = '/main/main'
      let paramsele = 'ele',
        paramswater = 'water'
      let p1 = api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(
        roleId,
        pagePath,
        paramsele
      )
      let p2 = api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(
        roleId,
        pagePath,
        paramswater
      )
      Promise.all([p1, p2]).then((res) => {
        //模拟数据
        // let list1 = [
        //   { name: "Sur-A", mpid: "800000000002" },
        //   { name: "Sur-B", mpid: "800000000003" },
        //   { name: "Tinting", mpid: "800000000004" },
        //   { name: "HC", mpid: "800000000005" },
        //   { name: "AR", mpid: "800000000006" },
        //   { name: "HR", mpid: "800000000007" },
        //   { name: "Packing", mpid: "800000000008" },
        //   { name: "LOG", mpid: "800000000009" },
        //   { name: "ME", mpid: "800000000010" },
        //   { name: "CEF", mpid: "800000000011" },
        // ];

        // let list2 = [
        //   { name: "Sur-A", mpid: "800000000002" },
        //   { name: "Sur-B", mpid: "800000000003" },
        //   { name: "Tinting", mpid: "800000000004" },
        //   { name: "HC", mpid: "800000000005" },
        //   { name: "AR", mpid: "800000000006" },
        //   { name: "HR", mpid: "800000000007" },
        //   { name: "ME", mpid: "800000000010" },
        // ];
        // this.elepieId = list1;
        // this.waterpieId = list2;
        //发布的时候启用
        this.elepieId = JSON.parse(res[0].data[0].value)
        this.waterpieId = JSON.parse(res[1].data[0].value)
        this.getPieChart()
      })
      // this.elepieId = JSON.parse(res[0].data[0].value)
      //   this.waterpieId = JSON.parse(res[1].data[0].value)
      //   this.getPieChart();
      /* this.piemyselfData = [
        { name: "CEF", mpid: "10001" },
        { name: "LOG", mpid: "10002" },
        { name: "ENG", mpid: "10003" }
      ];
      this.getPieChart();*/
    },
    getPieChart () {
      let vm = this
      /* [
                { measureId:1001, pointNumber:229,pointCode:'', data:[[{time, value}]]},
                { measureId:1001, pointNumber:401,pointCode:'', data:[[{time, value}]]},
                { measureId:1001, pointNumber:701,pointCode:'', data:[[{time, value}]]}
            ] */
      //[{measureId, pointNumber, pointCode}]
      let measuresele = [],
        measureswater = [],
        code = ['100229', '100401', '100701'] //电、水、产能
      let fromtime = formatDate(new Date(), 'yyyy-MM-dd') + ' 00:00:00'
      let nextDay = new Date()
      nextDay.setDate(nextDay.getDate() + 1)
      let totime = formatDate(nextDay, 'yyyy-MM-dd') + ' 00:00:00'
      /* this.piemyselfData.forEach((val, index) => {
          measuresele.push({
            measureId: val.mpid,
            pointNumber: "0",
            pointCode: "100229"
          });
          measureswater.push({
            measureId: val.mpid,
            pointNumber: "0",
            pointCode: "401"
          });
      }); */
      this.elepieId.forEach((val, index) => {
        measuresele.push({
          measureId: val.mpid,
          pointNumber: '0',
          pointCode: '100229',
        })
      })
      this.waterpieId.forEach((val, index) => {
        measureswater.push({
          measureId: val.mpid,
          pointNumber: '0',
          pointCode: '100401',
        })
      })
      vm.$api.quantity
        .getQuantityDay3(measuresele, fromtime, totime, null)
        .then((res) => {
          this.elepie = this.setPieData(this.elepieId, res.data)
        })
      vm.$api.quantity
        .getQuantityDay3(measureswater, fromtime, totime, null)
        .then((res) => {
          this.waterpie = this.setPieData(this.waterpieId, res.data)
        })
      //返回的数据
      /* let backdataele = [{measureId: 10001,pointNumber: 0,pointCode: "100229",data: [[{ time: "10", value: 5 }]]},{measureId: 10002,pointNumber: 0,pointCode: "100229",data: [[{ time: "10", value: 15 }]]}];
      let backdatawater = [{measureId: 10001,pointNumber: 0,pointCode: "401",data: [[{ time: "20", value: 5 }]]},{measureId: 10002,pointNumber: 0,pointCode: "100229",data: [[{ time: "10", value: 25 }]]}];
      this.elepie = this.setPieData(backdataele);
      this.waterpie = this.setPieData(backdatawater);
      console.log("888",this.elepie) */
    },
    setPieData (wichtypearr, backdata) {
      //期待数据格式[["CEF",'10']["LOG",'10']]
      let temp = []
      wichtypearr.forEach((item, i) => {
        temp[i] = []
        temp[i][0] = item.name
        let juge = backdata.find((val, index) => {
          return item.mpid == val.measureId
        })
        if (juge) {
          temp[i][1] =
            juge.data[0].length != 0 ? juge.data[0][0].value.toFixed(2) : 0
        } else {
          temp[i][1] = 0
        }
      })
      return temp
    },
    reFresh (piedata_) {
      /* 饼图 */
      var pieLegend = [],
        pieData = []
      piedata_.filter(function (val, i) {
        pieLegend.push(val[0])
        pieData.push({
          value: val[1],
          name: val[0],
        })
      })
      let dw = this.active == 'ele' ? 'kWh' : 'L'
      this.fillPie({
        legend: pieLegend,
        name: '',
        dw: dw,
        data: pieData,
      })
      /* 饼图 */
    },
    setLineData_ (tempdata) {
      //左下曲线
      var yName = this.active == 'ele' ? 'kWh' : 'm³'
      var lineLegend = [],
        lineX = [],
        lineSeries = [],
        lineData = []
      tempdata.filter(function (val, i) {
        lineLegend.push(val.name)
        val.data.filter(function (info, j) {
          if (i == 1) {
            lineX.push(info.time)
          }

          lineData.push(info.value)
        })

        lineSeries.push({
          name: val.name,
          type: 'line',
          data: lineData,
          markPoint: {
            data: [
              {
                type: 'max',
                name: '最大值',
                itemStyle: {
                  normal: {
                    label: {
                      textStyle: {
                        color: '#000',
                        fontWeight: 'bold',
                      },
                    },
                  },
                },
              },
              {
                type: 'min',
                name: '最小值',
                itemStyle: {
                  normal: {
                    label: {
                      textStyle: {
                        color: '#000',
                        fontWeight: 'bold',
                      },
                    },
                  },
                },
              },
            ],
          },
        })
        lineData = []
      })
      this.fillLine({
        legend: lineLegend,
        x: lineX,
        series: lineSeries,
        y: yName,
      })
    },
    fillPie (obj) {
      let this_ = this
      this.myChartPie = this.$echarts.init(document.getElementById('pie'))
      var option = {
        color: [
          '#3AA1FF',
          '#36CBCB',
          '#4ECB73',
          '#ACDF82',
          '#FBD437',
          '#dbb426',
          '#efd000',
          '#5e78d9',
        ],
        tooltip: {
          trigger: 'item',
          formatter: '{d}%',
          position: ['47%', '55%'],
          backgroundColor: 'transparent',
          textStyle: {
            color: '#000',
            fontSize: '25',
            fontWeight: 'bold',
          },
        },
        legend: {
          orient: 'horizontal',
          x: 'left',
          type: 'scroll',
          data: obj.legend,
        },
        series: [
          {
            name: obj.name,
            type: 'pie',
            radius: ['50%', '70%'],
            center: ['50%', '60%'],
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: '{b}\n{c}' + obj.dw + ' {d}%',
                },
              },
            },
            data: obj.data,
          },
        ],
      }
      this.myChartPie.setOption(option, true)
      window.addEventListener('resize', function () {
        if (this_.myChartPie) {
          this_.myChartPie.resize()
        }
      })
    },
    filltreepie (obj) {
      let this_ = this
      if (
        this_.Chartpietree != null &&
        this_.Chartpietree != '' &&
        this_.Chartpietree != undefined
      ) {
        this_.Chartpietree.dispose()
      }
      this_.Chartpietree = this.$echarts.init(
        document.getElementById('todaycharts')
      )
      var option = {
        tooltip: {
          formatter: '{a} <br/>{c} {b}',
        },
        series: [
          {
            title: '单片用电',
            name: '单片用电',
            type: 'gauge',
            z: 3,
            min: this_.chartMaxMinData.center.min,
            max: this_.chartMaxMinData.center.max,
            splitNumber: 10,
            radius: '70%',
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                width: 10,
              },
            },
            axisTick: {
              // 坐标轴小标记
              length: 15, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: 'auto',
              },
            },
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [
                  [this_.chartMaxMinData.center.oneMax, '#91c7ae'],
                  [this_.chartMaxMinData.center.twoMax, '#63869e'],
                  [1, '#c23531'],
                ],
                width: 10,
              },
            },
            splitLine: {
              // 分隔线
              length: 20, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: 'auto',
              },
            },
            axisLabel: {
              backgroundColor: 'auto',
              borderRadius: 2,
              color: '#eee',
              padding: 3,
              textShadowBlur: 2,
              textShadowOffsetX: 1,
              textShadowOffsetY: 1,
              textShadowColor: '#222',
            },
            title: {
              offsetCenter: [0, '95%'], // x, y，单位px
            },
            detail: {
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              formatter: function (value) {
                // value = (value + "").split(".");
                // value.length < 2 && value.push("00");
                // return (
                //   ("00" + value[0]).slice(-2) +
                //   "." +
                //   (value[1] + "00").slice(0, 2)
                // );
                return value
              },
              fontWeight: 'bolder',
              borderRadius: 3,
              backgroundColor: '#444',
              borderColor: '#aaa',
              shadowBlur: 5,
              shadowColor: '#333',
              shadowOffsetX: 0,
              shadowOffsetY: 3,
              borderWidth: 2,
              textBorderColor: '#000',
              textBorderWidth: 2,
              textShadowBlur: 2,
              textShadowColor: '#fff',
              textShadowOffsetX: 0,
              textShadowOffsetY: 0,
              fontSize: '16',
              fontFamily: 'Arial',
              offsetCenter: [0, '60%'],
              width: 70,
              color: '#eee',
              rich: {},
            },
            data: obj[0],
          },
          {
            name: '单片综合能耗',
            type: 'gauge',
            center: ['21%', '55%'], // 默认全局居中
            radius: '67%',
            min: this_.chartMaxMinData.left.min,
            max: this_.chartMaxMinData.left.max,
            endAngle: 45,
            splitNumber: 10,
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                width: 8,
              },
            },
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [
                  [this_.chartMaxMinData.left.oneMax, '#91c7ae'],
                  [this_.chartMaxMinData.left.twoMax, '#63869e'],
                  [1, '#c23531'],
                ],
                width: 8,
              },
            },
            axisTick: {
              // 坐标轴小标记
              length: 12, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: 'auto',
              },
            },
            splitLine: {
              // 分隔线
              length: 20, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: 'auto',
              },
            },
            pointer: {
              width: 5,
            },
            title: {
              offsetCenter: [0, '95%'], // x, y，单位px
            },
            detail: {
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              fontWeight: 'bolder',
            },
            data: obj[1],
          },
          {
            name: '单片用水',
            type: 'gauge',
            center: ['79%', '55%'], // 默认全局居中
            radius: '67%',
            min: this_.chartMaxMinData.right.min,
            max: this_.chartMaxMinData.right.max,
            startAngle: 135,
            endAngle: -45,
            splitNumber: 10,
            // axisLine: {
            //   // 坐标轴线
            //   lineStyle: {
            //     // 属性lineStyle控制线条样式
            //     width: 8,
            //   },
            // },
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [
                  [this_.chartMaxMinData.right.oneMax, '#91c7ae'],
                  [this_.chartMaxMinData.right.twoMax, '#63869e'],
                  [1, '#c23531'],
                ],
                width: 8,
              },
            },
            axisTick: {
              // 坐标轴小标记
              length: 12, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: 'auto',
              },
            },
            splitLine: {
              // 分隔线
              length: 20, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: 'auto',
              },
            },
            pointer: {
              width: 5,
            },
            title: {
              offsetCenter: [0, '95%'], // x, y，单位px
            },
            detail: {
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              fontWeight: 'bolder',
            },
            data: obj[2],
          },
        ],
      }
      this_.Chartpietree.setOption(option, true)
      if (this_.Chartpietree) {
        window.addEventListener('resize', function () {
          this_.Chartpietree.resize()
        })
      }
    },
    fillYearEcharts (obj) {
      let this_ = this
      if (
        this.myChartYearEcharts != null &&
        this.myChartYearEcharts != '' &&
        this.myChartYearEcharts != undefined
      ) {
        this.myChartYearEcharts.dispose()
      }
      this.myChartYearEcharts = this.$echarts.init(
        document.getElementById('yearEcharts')
      )
      var option = {
        tooltip: {
          trigger: 'axis',
          confine: true,
          formatter: function (params) {
            return (
              params[0].axisValue +
              '<br/>' +
              params[0].marker +
              params[0].seriesName +
              ':' +
              params[0].data
            )
          },
        },
        color: ['#7A29CC', '#00368c', '#e6bf00', '#2EA8E6', '#DC143C'],
        grid: {
          left: '1%',
          right: '5%',
          bottom: '20%',
          top: '5%',
          show: true,
          backgroundColor: '#EDEEF0',
          borderColor: '#dce1e7',
          containLabel: true,
        },
        legend: {
          data: ['Year', 'Month', 'Week', 'Day'],
          show: false,
        },
        xAxis: [
          {
            type: 'category',
            data: obj.xdata,
            axisLabel: {
              color: '#8A9099',
              fontSize: 10,
              fontFamily: 'FZLTHJW',
              interval: 0,
              rotate: -30,
            },
            axisTick: {
              show: true,
              alignWithLabel: true,
            },
            axisLine: {
              show: true,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: '#8A9099',
              fontSize: 10,
              fontFamily: 'FZLTHJW',
            },
            // max: 1,
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                color: ['#dce1e7'],
              },
            },
          },
        ],
        series: [
          {
            name: 'Year',
            type: 'bar',
            data: obj.ydata[0],
            label: {
              show: true,
              position: 'top',
              color: '#8A9099',
            },
            stack: 'bar',
          },
          {
            name: 'Month',
            type: 'bar',
            data: obj.ydata[1],
            label: {
              show: true,
              position: 'top',
              color: '#8A9099',
            },
            stack: 'bar',
          },
          {
            name: 'Week',
            type: 'line',
            data: obj.ydata[2],
            symbol: 'circle',
            symbolSize: 8,
            showAllSymbol: true,
            stack: 'bar',
            label: {
              show: true,
              position: 'top',
              color: '#8A9099',
            },
            markLine: {
              symbolSize: 0,
              data: [
                {
                  name: '',
                  yAxis: obj.warningLineValue,
                  lineStyle: {
                    color: '#DC143C',
                    type: 'dotted',
                  },
                },
              ],
            },
          },
          {
            name: 'Day',
            type: 'line',
            data: obj.ydata[3],
            symbol: 'circle',
            symbolSize: 8,
            showAllSymbol: true,
            stack: 'bar',
            label: {
              show: true,
              position: 'top',
              color: '#8A9099',
            },
          },
        ],
      }

      this.myChartYearEcharts.setOption(option, true)

      document.getElementsByClassName('countUl')[0].style.width =
        this.myChartYearEcharts.getWidth() * 0.9 + 'px'

      document.getElementsByClassName('countUl')[0].childNodes[0].style.width =
        (
          (document.getElementsByClassName('countUl')[0].style.width / 19) *
          2
        ).toFixed(2) + 'px'

      document.getElementsByClassName('countUl')[0].childNodes[1].style.width =
        (
          (document.getElementsByClassName('countUl')[0].style.width / 19) *
          5
        ).toFixed(2) + 'px'

      document.getElementsByClassName('countUl')[0].childNodes[2].style.width =
        (
          (document.getElementsByClassName('countUl')[0].style.width / 19) *
          5
        ).toFixed(2) + 'px'

      document.getElementsByClassName('countUl')[0].childNodes[3].style.width =
        (
          (document.getElementsByClassName('countUl')[0].style.width / 19) *
          7
        ).toFixed(2) + 'px'

      window.addEventListener('resize', function () {
        this_.myChartYearEcharts.resize()
        document.getElementsByClassName('countUl')[0].style.width =
          this_.myChartYearEcharts.getWidth() * 0.9 + 'px'

        document.getElementsByClassName(
          'countUl'
        )[0].childNodes[0].style.width =
          (
            (document.getElementsByClassName('countUl')[0].style.width / 19) *
            2
          ).toFixed(2) + 'px'

        document.getElementsByClassName(
          'countUl'
        )[0].childNodes[1].style.width =
          (
            (document.getElementsByClassName('countUl')[0].style.width / 19) *
            5
          ).toFixed(2) + 'px'

        document.getElementsByClassName(
          'countUl'
        )[0].childNodes[2].style.width =
          (
            (document.getElementsByClassName('countUl')[0].style.width / 19) *
            5
          ).toFixed(2) + 'px'

        document.getElementsByClassName(
          'countUl'
        )[0].childNodes[3].style.width =
          (
            (document.getElementsByClassName('countUl')[0].style.width / 19) *
            7
          ).toFixed(2) + 'px'
      })
    },
    fillLine (obj) {
      let this_ = this
      this_.myChartLine = this_.$echarts.init(document.getElementById('line'))
      var option = {
        tooltip: {
          trigger: 'axis',
        },
        backgroundColor: '#FFF',
        color: [
          '#1890FF',
          '#2FC25B',
          '#21A496',
          '#00388C',
          '#EE9A00',
          '#008100',
          'maroon',
          '#cb28c7',
          '#047c7d',
          '#4d5151',
          '#efd000',
          '#5e78d9',
        ],
        legend: {
          data: obj.legend,
        },
        grid: {
          left: '2%',
          right: '2%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: obj.x,
        },
        yAxis: {
          type: 'value',
          name: obj.y,
        },
        series: obj.series,
      }
      this_.myChartLine.setOption(option, true)
      window.addEventListener('resize', function () {
        if (this_.myChartLine) {
          this_.myChartLine.resize()
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 10px;
  box-sizing: border-box;
}
.boxbgcolor {
  background: #f5f5f5;
}
.el-row {
  width: 100%;
  height: 50%;
  margin: 0 !important;
  padding-bottom: 0.5rem;
}
.el-col {
  border-radius: 4px;
  height: 100%;
}
.grid-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 0 10px 2px #ccd7e8;
  border: 1px solid #ccd7e8;
  border-radius: 10px;
}
.parentflex {
  position: relative;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
}
.parentflex > p {
  width: 100%;
  height: 1.75rem;
  line-height: 1.75rem;
  font-size: 1.2rem;
  padding-left: 1rem;
  font-weight: bold;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.parentflex_main {
  position: relative;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
}
.parentflex_main > p {
  width: 100%;
  height: 1.75rem;
  line-height: 1.75rem;
  font-size: 0.9rem;
  padding-left: 1rem;
  font-weight: bold;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.content {
  position: absolute;
  top: 40px;
  bottom: 5px;
  left: 5px;
  right: 5px;
}
/* 左上卡片 */
.relative {
  position: relative;
}
.box_ {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 10px;
  box-sizing: border-box;
}
.flex {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.cardflex {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 45%;
}
.card {
  width: 33%;
  height: 100%;
  border: 1px solid #cccccc;
  margin: 5px;
  border-radius: 3px;
}
.parentbox {
  display: flex;
  flex-direction: column;
}
.valuebox {
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.bgpadding {
  padding: 6%;
  box-sizing: border-box;
}
.valuebg {
  color: #002f7a;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border-radius: 3px;
}
.energyImg {
  display: inline-block;
  width: 1.65rem;
  height: 1.65rem;
  border-radius: 1.65rem;
}
.yearele_ {
  background: #fff url(~@/assets/image/index/ele_main.png) no-repeat center
    center;
}
.yearWater_ {
  background: #fff url(~@/assets/image/index/water_main.png) no-repeat center
    center;
}
.yearall_ {
  background: #fff url(~@/assets/image/index/all_main.png) no-repeat center
    center;
}
.valuebgcolor {
  background: #cfd0d2;
}
.valuebg p {
  color: #002f7a;
  font-size: 20px;
}
.danwei {
  font-size: 16px;
}
.bluetxt {
  font-size: 20px;
  font-weight: bold;
}
.bluecolor {
  color: #002f7a;
}
.count {
  position: absolute;
  top: 48px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  box-shadow: 0 0 10px 2px #ccd7e8;
  padding: 20px;
  box-sizing: border-box;
}
.dayLink {
  display: flex;
  float: right;
  margin: 0rem 0.5rem 0 0;
  align-items: center;
  height: 33px;
}
.dayLink a {
  display: inline-block;
  width: 28px;
  height: 28px;
  border-radius: 28px;
  overflow: hidden;
  margin-right: 0.5rem;
}
.dayLink .dayWater {
  background: #83cbf1 url(~@/assets/image/index/icon.png) no-repeat -12px -359px;
  cursor: pointer;
}
.dayLink .dayElect {
  background: #83cbf1 url(~@/assets/image/index/icon.png) no-repeat -12px -328px;
  cursor: pointer;
}
.dayLink .dayLng {
  background: #83cbf1 url(~@/assets/image/index/icon.png) no-repeat -12px -390px;
}
.dayLink .active {
  background-color: #00388c;
}
.water {
  background: #fff url(~@/assets/image/index/zhnyashui.png) no-repeat center
    center;
}
.elect {
  background: #fff url(~@/assets/image/index/zhnyadian.png) no-repeat center
    center;
}
.texttyle {
  width: 100%;
  height: 1.75rem;
  line-height: 1.75rem;
  font-size: 1.2rem;
  padding-left: 1rem;
  font-weight: bold;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
/* 左上卡片 */
/* 右上 */
ul {
  margin: 8px 0;
}
.countUl {
  list-style: none;
  overflow: hidden;
  display: flex;
  margin-left: -1%;
}
.countUl li {
  font-size: 0.6rem;
  line-height: 20px;
  box-sizing: border-box;
  margin-right: 10px;
  text-align: center;
}
/* 右上 */
.pagebox {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
